import { defineComponent as _defineComponent } from 'vue'
import { AddressSuggestion } from '@/modules/Client/Interfaces/AddressSuggestion';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressSuggestionsModal',
  props: {
    visible: { type: Boolean },
    suggestions: null
  },
  emits: ["cancel", "select"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'cancel'): void;
    (e: 'select', suggestion: AddressSuggestion): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit }
}

})